<!--  *************************  -->
<!--        CHARTS TOPBAR        -->
<!--  *************************  -->

<ng-container *ngIf="appService.menuVoice?.name === Paths.CHARTS">
  <app-chart-controls class="customElementsContainer topbarAfter"></app-chart-controls>
</ng-container>

<!--  *************************  -->
<!--      DASHBOARD TOPBAR       -->
<!--  *************************  -->

<ng-container *ngIf="appService.menuVoice?.name === Paths.DASHBOARD">

  <dx-button
    *ngIf="!dashboardService.dashboardEditMode && !dashboardService.isImpersonatingUser()"
    (onClick)="createNewDashboard()"
    [disabled]="disabled"
    [stylingMode]="'text'"
    [title]="'BUTTONS.HINTS.ADD_DASHBOARD' | translate"
    hint="{{'BUTTONS.HINTS.ADD_DASHBOARD' | translate}}">
    <i class="vr-ic_fluent_add_24_regular"></i>
  </dx-button>

  <dx-button
    *ngIf="!dashboardService.dashboardEditMode && !dashboardService.isImpersonatingUser()"
    (onClick)="changeEdit(true)"
    [disabled]="!dashboardService.userDashboards || dashboardService.userDashboards.length === 0 || disabled"
    [stylingMode]="'text'"
    [title]="'BUTTONS.HINTS.EDIT_DASHBOARD' | translate"
    hint="{{'BUTTONS.HINTS.EDIT_DASHBOARD' | translate}}">
    <i class="vr-ic_fluent_edit_24_regular"></i>
  </dx-button>


  <dx-button
    (onClick)="editDashboard()"
    *ngIf="dashboardService.dashboardEditMode"
    [disabled]="!dashboardService.userDashboards || dashboardService.userDashboards.length === 0 || disabled"
    [stylingMode]="'text'">
    <i class="vr-ic_fluent_slide_add_24_regular"></i>
  </dx-button>

  <dx-button
    (onClick)="changeEdit(false)"
    *ngIf="dashboardService.dashboardEditMode"
    [disabled]="disabled"
    [stylingMode]="'text'">
    <i class="vr-ic_fluent_checkmark_24_regular"></i>
  </dx-button>


</ng-container>


<!--  *************************  -->
<!--        GLOBAL TOPBAR        -->
<!--  *************************  -->

<dx-button
  (onClick)="openDiagnosticPage()"
  *ngIf="!!appService.menuVoice"
  [disabled]="disabled"
  [stylingMode]="'text'">
  <i *ngIf="appService.menuVoice?.name !== Paths.DIAGNOSTICS" class="vr-ic_fluent_heart_pulse_24_regular"></i>
  <i *ngIf="appService.menuVoice?.name === Paths.DIAGNOSTICS" class="vf-ic_fluent_heart_pulse_24_filled"></i>
</dx-button>

<dx-button
  (onClick)="openAlarmsPage()"
  *ngIf="!!appService.menuVoice"
  [disabled]="disabled"
  [stylingMode]="'text'">
  <i *ngIf="appService.menuVoice?.name !== Paths.ALERTS" class="vr-ic_fluent_alert_urgent_24_regular"></i>
  <i *ngIf="appService.menuVoice?.name === Paths.ALERTS" class="vf-ic_fluent_alert_urgent_24_filled"></i>
</dx-button>
